import React from 'react';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { JsdGettingStartedPanelShouldRender } from '@atlassian/jira-servicedesk-getting-started-panel/src/async';
import { useInitializeActiveTab } from '@atlassian/jira-servicedesk-getting-started-panel/src/services/hooks/useInitializeActiveTab';
import { ResponderAlertsConfigurationContainer } from '@atlassian/jira-servicedesk-incident-management-settings/src/services/main.tsx';
import { IncidentManagementSettings as IncidentManagementSettingsApp } from '@atlassian/jira-servicedesk-incident-management-settings/src/ui/index.tsx';
import { ServiceDeskDocumentTitle } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/document-title/index.tsx';
import { toProjectId } from '@atlassian/jira-shared-types/src/general.tsx';
import AppContainer from '@atlassian/jira-spa-apps-project-settings-common/src/components/app-container';
import { useResource } from '@atlassian/react-resource-router';
import { IncidentManagementSettingsPageContainer } from './styled';

export const ServiceDeskIncidentManagementSettings = () => {
	const baseUrl = '';
	const { data: projectContext } = useResource(projectContextResource);
	/**
	 * Initializes the active tab to 'incidents' within the Getting Started Panel
	 * specifically for NPLE for ITSM experiment.
	 */
	useInitializeActiveTab('incidents');

	if (projectContext == null) {
		return null;
	}

	return (
		<>
			<ServiceDeskDocumentTitle
				projectName={projectContext.projectName}
				section="incidentManagementSettings"
			/>
			<AppContainer baseUrl={baseUrl} projectKey={projectContext.projectKey}>
				<IncidentManagementSettingsPageContainer>
					<ResponderAlertsConfigurationContainer
						scope={toProjectId(projectContext.projectId.toString())}
					>
						<IncidentManagementSettingsApp />
					</ResponderAlertsConfigurationContainer>
				</IncidentManagementSettingsPageContainer>
			</AppContainer>
			<JsdGettingStartedPanelShouldRender />
		</>
	);
};

ServiceDeskIncidentManagementSettings.displayName = 'ServiceDeskIncidentManagementSettings';
